/**
 * @generated SignedSource<<936c46fb8b86a0de73b9c8e2e34bf5b5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type queueFragment_ScheduleSaveMutation$variables = {
  enabled?: boolean | null | undefined;
  everyMinutes?: number | null | undefined;
  kind?: string | null | undefined;
  scheduleId?: number | null | undefined;
};
export type queueFragment_ScheduleSaveMutation$data = {
  readonly jobScheduleSave: {
    readonly errors: ReadonlyArray<{
      readonly message: string;
    }>;
    readonly schedule: {
      readonly scheduleId: number;
    } | null | undefined;
  } | null | undefined;
};
export type queueFragment_ScheduleSaveMutation = {
  response: queueFragment_ScheduleSaveMutation$data;
  variables: queueFragment_ScheduleSaveMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "enabled"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "everyMinutes"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "kind"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "scheduleId"
},
v4 = [
  {
    "kind": "Variable",
    "name": "enabled",
    "variableName": "enabled"
  },
  {
    "kind": "Variable",
    "name": "everyMinutes",
    "variableName": "everyMinutes"
  },
  {
    "kind": "Variable",
    "name": "kind",
    "variableName": "kind"
  },
  {
    "kind": "Variable",
    "name": "scheduleId",
    "variableName": "scheduleId"
  }
],
v5 = {
  "alias": null,
  "args": null,
  "concreteType": "JobSchedule",
  "kind": "LinkedField",
  "name": "schedule",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "scheduleId",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "message",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "queueFragment_ScheduleSaveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "JobScheduleSaveMutationPayload",
        "kind": "LinkedField",
        "name": "jobScheduleSave",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v6/*: any*/)
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v3/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "queueFragment_ScheduleSaveMutation",
    "selections": [
      {
        "alias": null,
        "args": (v4/*: any*/),
        "concreteType": "JobScheduleSaveMutationPayload",
        "kind": "LinkedField",
        "name": "jobScheduleSave",
        "plural": false,
        "selections": [
          (v5/*: any*/),
          {
            "alias": null,
            "args": null,
            "concreteType": "UserError",
            "kind": "LinkedField",
            "name": "errors",
            "plural": true,
            "selections": [
              (v6/*: any*/),
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "4517d891a86b60f39d65e5e5d5b2dd9c",
    "id": null,
    "metadata": {},
    "name": "queueFragment_ScheduleSaveMutation",
    "operationKind": "mutation",
    "text": "mutation queueFragment_ScheduleSaveMutation(\n  $scheduleId: Int\n  $kind: String\n  $everyMinutes: Int\n  $enabled: Boolean\n) {\n  jobScheduleSave(scheduleId: $scheduleId, kind: $kind, everyMinutes: $everyMinutes, enabled: $enabled) {\n    schedule {\n      scheduleId\n    }\n    errors {\n      message\n      id\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "20713cfacfdd26fce89551b767fd7a5d";

export default node;
